import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "./axiosConfig";
import apiConfig, { API_BASE_URL } from "../config/apiConfig";

// Refresh token fonksiyonu
const buildApiUrl = (path) => {
  const normalizedBase = API_BASE_URL.replace(/\/?$/, "/");
  return `${normalizedBase}${path.replace(/^\/+/, "")}`;
};

export const refreshToken = async () => {
  try {
    const refreshTokenValue = localStorage.getItem("refreshToken");

    if (!refreshTokenValue) {
      // Refresh token yoksa direkt logout yap
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      throw new Error("No refresh token available - user must login again");
    }

    // Refresh token isteği için normal axios kullan (interceptor olmadan)
    const response = await axios.post(buildApiUrl("refreshToken"), refreshTokenValue, {
      headers: {
        "Content-Type": "text/plain",
      },
      timeout: apiConfig.timeout,
    });

    const { jwt, refreshToken: newRefreshToken } = response.data;

    // Yeni tokenları localStorage'a kaydet
    localStorage.setItem("authToken", jwt);
    localStorage.setItem("refreshToken", newRefreshToken);

    return jwt;
  } catch (error) {
    console.error(
      "AuthService: Refresh token error:",
      error.response?.status,
      error.response?.data
    );
    // Refresh token da geçersizse sadece localStorage'ı temizle
    // window.location.href kullanma, UserContext'te handle edilsin
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    throw error;
  }
};

export const authenticateUser = async (username, password, setUser) => {
  try {
    const normalizedUsername = (username || "").trim().toLowerCase();
    const response = await axios.post(
      buildApiUrl("authenticate"),
      {
        username: normalizedUsername,
        password,
      },
      {
        withCredentials: false,
        timeout: apiConfig.timeout,
      }
    );

    // JWT ve refresh token'ı localStorage'a kaydet
    localStorage.setItem("authToken", response.data.jwt);
    localStorage.setItem("refreshToken", response.data.refreshToken);

    // Kullanıcı bilgilerini axios instance ile al
    const userResponse = await axiosInstance.get("users/me");
    const userData = userResponse.data;
    setUser(userData);
    return { success: true, data: userData };
  } catch (error) {
    toast.error(`Kullanıcı bilgileri hatalı`, { position: "top-right" });
    return { success: false, error: error.response?.data || "Login failed" };
  }
};

export const checkAuthToken = () => {
  if (window.location.pathname !== "/login") {
    const token = localStorage.getItem("authToken");
    if (!token) {
      return false;
    }
    return true;
  }
  return true;
};

// Logout fonksiyonu
export const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  // window.location.href yerine navigate kullanılacak (UserContext'te)
};
